import { tableSchema } from '@nozbe/watermelondb';

export const userSchema = tableSchema({
  name: 'users',
  columns: [
    {
      name: 'user_id',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'username',
      type: 'string',
    },
    {
      name: 'role',
      type: 'string',
    },
    {
      name: 'token',
      type: 'string',
    },
    {
      name: 'session_id',
      type: 'string',
    },
  ],
});
